export default "__VITE_ASSET__CebdMF_b__"